import { createStore } from "vuex";
import { v4 as uuidv4 } from 'uuid';

export const defaultNote = {
  id: null,
  title: '',
  content: '',
  tags: '',
  timestamp: null
}

const initialState = () => {
  return { 
    user: null, 
    error: null, 
    notes: [],
    activeNote: {
      id: null,
      title: '',
      content: '',
      tags: '',
      timestamp: null
    },
    filterText: null,
  };
};

export default createStore({
  state: initialState(),
  mutations: {
    setNotes(state, notes) {
      state.notes = notes
    },

    addNote(state, note) {
      note.id = uuidv4()
      state.notes.push(note);
    },

    updateNote(state, updatedNote) {
      state.notes = state.notes.map((note) => {
        if (note.id === updatedNote.id) {
          return updatedNote;
        }

        return note;
      })
    },

    removeNote(state, searchedNote) {
      state.notes = state.notes.filter((note) => {
        return note.id !== searchedNote.id
      })
    },

    setActiveNote(state, note) {
      state.activeNote = note
    },

    setFilterText(state, text) {
      state.filterText = text
    },

    login(state, user) {
      state.user = user
    },

    logout(state) {
      state.user = null
    }
  },
  actions: {},
  modules: {},
});
